import { IEngagementContext, TNotificationOrigin } from '~/domain/OfficeNotification';
import PosthogService from '~/services/posthog/PosthogService';

export interface IOfficeNotificationCandidateAppliedPayload {
  origin: TNotificationOrigin;
  shiftId: string;
  professionalId: string;
  engagement: IEngagementContext;
}

/**
 * Fires when an office lands on the Confirm Candidate page from a
 * "candidate applied" email CTA.
 * Event: dental_portal:office_notification:candidate_applied
 */
export function fireOfficeNotificationCandidateApplied(
  payload: IOfficeNotificationCandidateAppliedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:office_notification:candidate_applied', {
    origin: payload.origin,
    shift_id: payload.shiftId,
    professional_id: payload.professionalId,
    ...payload.engagement,
  });
}
